import { c as _c } from "react/compiler-runtime";
import React from "react";
import Svg from "../Svg";
const Icon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M4.5 5.59459C4.5 5.59459 4.11111 1 8 1C11.8889 1 11.5 5.59459 11.5 5.59459M1 17.0811L1.72097 5.15587C1.75288 4.62798 2.1903 4.21622 2.71914 4.21622H13.2852C13.8123 4.21622 14.2487 4.62316 14.2828 5.14912C14.5543 9.34688 15 16.3995 15 17.0811C15 17.8162 14.4815 18 14.2222 18C10.3333 18 2.4 18 1.77778 18C1.15556 18 1 17.3874 1 17.0811Z" stroke="#D84935" strokeLinecap="round" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg width={16} height={19} viewBox="0 0 16 19" fill="none" {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default Icon;